import Vue from 'vue'
import Vuex from 'vuex'

import {Storage, resetState} from '@/utils/Storage'
import {ApiUtils} from '@/utils/ApiUtils'

import ProviderPanelData from '@/modules/providerPanelData'
import preloads from '@/modules/preloads'
import services from '@/modules/services'
import quotations from '@/modules/quotations'
import payments from '@/modules/payments'
import branches from '@/modules/branches'
import offers from '@/modules/offers'
import userQuotations from '@/modules/userQuotations'
import clientAttention from '@/modules/clientAttention'

Vue.use(Vuex)
const moment = require('moment')

const initialState = () => {
    return {
        blurred: false,
        isOnline: true,
        loader: false,
        globalLoading: false,
        eventStatuses: [],
        showBackToEvent: true,
        backToEvent: null,
        showLogin: false,
        showLogout: false,
        loginMessage: '',
        loadingLogin: false,
        firstLoadingLogin: false,
        persistentLogin: false,
        currentUser: Storage.getUser(),
        userDataComplete: false,
        institutionDataComplete: false,
        currentProvider: null,
        currentBranchOffice: null,
        branchOffices: [],
        clientListIsVisible: false,
        regions: [],
        snackBarModel: false,
        snackBarText: '',
        snackBarColor: 'success',
        loadingPhysicalExams: false,
        availablePhysicalExams: [],
        echoInstance: null,
    }
}

export default new Vuex.Store({
    modules: {
        provider: ProviderPanelData,
        preloads,
        services,
        quotations,
        branches,
        payments,
        offers,
        userQuotations,
        clientAttention
    },
    state: {

        // Global
        blurred: false,
        isOnline: true,
        loader: false,
        globalLoading: false,
        eventStatuses: [],
        showBackToEvent: true,
        backToEvent: null,

        // Login
        showLogin: false,
        showLogout: false,
        loginMessage: '',
        loadingLogin: false,
        firstLoadingLogin: false,
        persistentLogin: false,

        // User
        currentUser: Storage.getUser(),
        userDataComplete: false,
        institutionDataComplete: false,

        //Provider
        currentProvider: null,
        currentBranchOffice: null,
        branchOffices: [],

        //Specialists
        clientListIsVisible: false,

        //Regions
        regions: [],

        snackBarModel: false,
        snackBarText: '',
        snackBarColor: 'success',

        //Exams
        loadingPhysicalExams: false,
        availablePhysicalExams: [],

        //sockets
        echoInstance: null,

    },
    mutations: {
        reset: (state) => {
            const s = initialState()
            resetState(state, s);
        },

        setIsOnline: (state, isOnline) => {
            state.isOnline = isOnline;
        },

        setBackToEvent(state, payload) {
            state.backToEvent = payload.event || null
            state.showBackToEvent = payload.show || false
        },

        setGlobalLoading(state, loading) {
            state.globalLoading = loading
        },
        setLaravelEchoInstance(state, echo) {
            state.echoInstance = echo
        },
        setEventStatuses(state, statuses = []) {
            state.eventStatuses = statuses
        },
        setLoadingPhysicalExams(state, loading) {
            state.loadingPhysicalExams = loading
        },
        setAvailablePhysicalExams(state, exams = []) {
            state.availablePhysicalExams = exams
        },
        setRegions(state, regions = []) {
            state.regions = regions
        },
        blurWrapper(state, blur) {
            state.blurred = blur
        },
        showLoader(state) {
            state.loader = true
        },
        hideLoader(state) {
            state.loader = false
        },
        setLoginMessage(state, message = '') {
            state.loginMessage = message
        },
        setLoginLoading(state, isLoading = false) {
            state.loadingLogin = isLoading
        },
        setFirstLoginLoading(state, isLoading = false) {
            state.firstLoadingLogin = isLoading
        },
        showSnackBar(state, payload) {

            state.snackBarText = typeof payload === 'object' && payload.text || payload
            state.snackBarColor = typeof payload === 'object' && payload.color || 'grey darken-3'
            state.snackBarModel = true
        },
        setSnackBarModel(state, value) {
            state.snackBarModel = value
        },
        hideSnackBar(state) {
            state.snackBarModel = false
        },
        setCurrentUser(state, user) {

            state.currentUser = user
            if (!user) {
                state.currentProvider = null
                state.currentBranchOffice = null
                return
            }

            if (user.service_providers && user.service_providers.length > 0) {
                let providerToSelect = user.service_providers[0]
                if (state.currentProvider) {
                    const userProvider = user.service_providers.find(prov => prov.id === state.currentProvider.id)
                    if (userProvider) {
                        providerToSelect = userProvider
                    }
                }

                state.currentProvider = providerToSelect

                if (
                    providerToSelect.institution &&
                    providerToSelect.institution.branch_offices &&
                    providerToSelect.institution.branch_offices.length > 0
                ) {
                    state.branchOffices = providerToSelect.institution.branch_offices
                    let branchToSet = providerToSelect.institution.branch_offices[0]

                    if (state.currentBranchOffice) {
                        const foundBranchOffice = providerToSelect.institution.branch_offices
                            .find(off => off.id === state.currentBranchOffice.id)
                        if (foundBranchOffice) {
                            branchToSet = foundBranchOffice
                        }
                    }

                    state.currentBranchOffice = branchToSet

                }

            } else {
                state.currentProvider = null
            }

        },
        setCurrentProvider(state, {provider, office}) {
            state.currentProvider = provider
            if (
                provider.institution &&
                provider.institution.branch_offices &&
                provider.institution.branch_offices.length > 0
            ) {
                state.branchOffices = provider.institution.branch_offices
                if (office) {
                    const officeBelongsToProvider = provider.institution.branch_offices
                        .find(off => off.id === office.id);
                    if (officeBelongsToProvider) {
                        state.currentBranchOffice = office
                    }
                } else {
                    state.currentBranchOffice = provider.institution.branch_offices[0]
                }

            } else {
                state.currentBranchOffice = null
            }
        },
        setBranchOffices(state, offices) {
            state.branchOffices = offices
        },
        setCurrentBranchOffice(state, office) {
            state.currentBranchOffice = office
        },
        toggleLogin(state) {
            state.showLogin = !state.showLogin
        },
        openLoginForm(state, persistent = false) {
            state.showLogin = true
            state.persistentLogin = persistent
        },
        closeLoginForm(state) {
            state.showLogin = false
        },
        setLogoutVisibility(state, visibility = true) {
            state.showLogout = visibility
        },
        setUserDataComplete(state, complete = false) {
            state.userDataComplete = complete
        },
        setInstitutionDataComplete(state, complete = false) {
            state.institutionDataComplete = complete
        },
        showClientList(state) {
            state.clientListIsVisible = true
        },
        hideClientList(state) {
            state.clientListIsVisible = false
        }
    },
    actions: {

        resetAll({commit}) {
            commit("reset")
            commit("provider/reset")
            commit("preloads/reset")
            commit("services/reset")
            commit("quotations/reset")
            commit("branches/reset")
            commit("payments/reset")
            commit("offers/reset")
            commit("userQuotations/reset")
            commit("clientAttention/reset")
        },

        async fetchPhysicalExams(context, providerId) {

            context.commit('setLoadingPhysicalExams', true)
            const response = await ApiUtils.makeGet(`providers/${providerId}/exams/physical/all`);
            context.commit('setLoadingPhysicalExams', false)

            if (response.ok) {
                const json = await response.json()
                context.commit('setAvailablePhysicalExams', json.result.physical_exams)
            }

        },

        async fetchBranchOffices(context) {
            const currentProvider = context.state.currentProvider

            if (!currentProvider) return
            var url = `provider/${currentProvider.id}/branch-offices`
            var response = await ApiUtils.makeGet(url)
            if (!response.ok) {

                return
            }

            const json = await response.json()
            context.commit('setBranchOffices', json.result.branch_offices)

        },
        async fetchRegions(context) {
            const response = await ApiUtils.makeGet('public/regions');
            if (response.ok) {
                const json = await response.json()
                context.commit('setRegions', json.result.regions)
            }
        }
    },
    getters: {
        availableProviders(state) {
            const {currentUser} = state
            if (!currentUser) return []
            return currentUser.service_providers
        },
        currentProviderName(state) {
            if (!state.currentProvider) return ''
            if (state.currentProvider.institution) return state.currentProvider.institution.name
            return `${state.currentProvider.user.first_name} ${state.currentProvider.user.last_name}`
        },
        specialistSettings(state) {
            const {currentProvider} = state
            return currentProvider && currentProvider.specialist_settings || null
        },
        isOnBoardingDone(state) {
            return !(state.currentUser && state.currentUser.account_type === 'provider' && !state.currentProvider)
        },
        isOwner: (state, getters) => {
            const role = getters.currentRole
            if (!role) return false
            return role.is_owner
        },
        isAdmin: (state, getters) => {
            const role = getters.currentRole
            if (!role) return false
            return role.is_admin
        },
        currentRole: state => {
            const currentProvider = state.currentProvider
            if (!currentProvider) return null
            return currentProvider.role || null
        },
        subscriptionWasCancelled: (state, getters) => {
            return getters.currentSubscription && ![1, 2].includes(Number(getters.currentSubscription.status))
        },
        accountSuspended: state => {
            return state.currentProvider && Boolean(state.currentProvider.suspended_account)
        },
        subscriptionPaused: state => {
            return state.currentProvider && Boolean(state.currentProvider.subscription_paused)
        },
        currentSubscription: state => {
            return state.currentProvider && state.currentProvider.subscription || null
        },
        noBillingData: (state, getters) => {
            if (!getters.currentSubscription) return true
            return !getters.currentSubscription.dni || !getters.currentSubscription.business_name ||
                !getters.currentSubscription.business_sector || !getters.currentSubscription.commune ||
                !getters.currentSubscription.city || !getters.currentSubscription.address
        },
        paymentFailed: state => {
            return !!state.currentSubscription
                && state.currentSubscription.charges_retries_number !== undefined
                && state.currentSubscription.charges_retries_number > 0
        },
        planPurchaseNeeded: (state, getters) => {
            return getters.trialIsExpired && !getters.currentSubscription
        },
        subscribedPlan: (state, getters) => {
            const {currentSubscription} = getters
            if (!currentSubscription) return null
            return currentSubscription.subscription_plan
        },
        allowPublicProfile(state, getters) {
            const {subscribedPlan} = getters
            if (!subscribedPlan) return false
            const {features} = subscribedPlan
            return features.includes('public_profile')
        },
        allowVC(state, getters) {
            const {subscribedPlan} = getters
            if (!subscribedPlan) return false
            const {features} = subscribedPlan
            return features.includes('vc')
        },
        allowOnlinePayments(state, getters) {
            const {subscribedPlan} = getters
            if (!subscribedPlan) return false
            const {features} = subscribedPlan
            return features.includes('payments')
        },
        accountExpirationDate: state => {
            if (process.env.NODE_ENV === 'development' || (state.currentUser && state.currentUser.id === 1)) return null
            const currentProvider = state.currentProvider
            if (!currentProvider) return null
            if (currentProvider.trial_expires_at) return currentProvider.trial_expires_at
            const creationDate = moment(currentProvider.created_at)
            const trialDays = process.env.VUE_APP_TRIAL_PERIOD_DAYS || 15
            creationDate.add('days', trialDays)
            return creationDate.format('YYYY-MM-DD HH:mm:ss')
        },
        trialIsExpired: (state, getters) => {
            const {accountExpirationDate} = getters
            if (!accountExpirationDate) return false
            const now = moment()
            return moment(accountExpirationDate).isBefore(now)
        },
        currentUser: (state) => state.currentUser,
        currentProvider: (state) => state.currentProvider,
        regions: (state) => state.regions,
        communes: (state) => {
            let all = []
            state.regions.forEach(region => {
                all.push({header: region.name})
                region.communes.forEach(commune => {
                    all.push({id: commune.id, name: commune.name})
                })
            })
            return all
        },
        commune: (state) => (id) => {
            let all = []
            state.regions.forEach(region => {
                all.push({header: region.name})
                region.communes.forEach(commune => {
                    all.push({id: commune.id, name: commune.name})
                })
            })
            return all.find(comm => comm.id === id)
        }
    }
})
